import React from 'react';
import { Link } from 'react-router-dom';
import Tooltip from '@material-ui/core/Tooltip';
import { css, StyleSheet } from 'aphrodite';

import { ApiHelper } from '../../common/helpers/ApiHelper';
import { Helper } from '../../common/helpers/Helper';
import { BaseEntityPage } from '../../common/components/BaseEntityPage';
import { UiHelper } from '../../common/helpers/UiHelper';
import { AppStyles } from '../../styles/AppTheme';
import { SearchBar } from '../../common/components/SearchBar';
import { AppUiHelper } from '../../helpers/AppUiHelper';

export class Venuegroups extends BaseEntityPage {

  constructor(props) {
    super(props)
    this.pageKey = 'VenueGroups'
    this.pageTitle = Helper.getString('venuegroups')
    this.orgId = this.props.match.params.orgId || 'PRODUCT'
    this.uploadLocation = this.orgId
    this.breadCrumbs = [
      { title: Helper.getString('home'), to: this.baseRoute({ home: true }) },
      { title: this.pageTitle },
    ]
    this.toFetch = [
      { method: 'GET', paths: ['miscs', 'venuegroups'], queryParams: { groupId: this.orgId, pb: 'fieldDef', state:'LIVE' } },
      { method: 'GET', paths: ['campaigns'], queryParams: { groupId: 'PRODUCT' } },
    ]
    this.tableHeadersMap = {
      Index: (current) => current.__index + 1,
      Info: (current) => current.title,
      Campaigns: (current) => `Campaigns (${current.campaigns.length})`,
      Type: (current) => {
        return (
          <div>
            {current.state === 'LIVE' || !current.state ? AppUiHelper.chipLive(current.state || 'LIVE') : AppUiHelper.chipDisabled(current.state)}
          </div>
        )
      }
    }
    this.tableHeaders = Object.keys(this.tableHeadersMap)
    this.apiData = {
      groupId: this.orgId
    }
    this.noTableHead = true
  }

  onFetchSuccess(results) {
    this.formDefinition = this.fieldDef = results[0].fieldDef
    UiHelper.populateOptions(this.fieldDef, results[1], 'campaigns')
    this.setState({
      items: results[0].items,
      stateFilterValue: 'LIVE',
      searchText: ''
    })
  }

  onTableValue(current, index) {
    if (!this.tableHeaders[index]) return ''
    return this.tableHeadersMap[this.tableHeaders[index]](current)
  }

  onAdd() {
    this.setState({
      apiMethod: 'POST',
      apiEndPoint: ApiHelper.makeUrlPath(['venuegroups']),
    });
  }

  onEdit(current) {
    this.setState({
      apiMethod: 'PUT',
      apiEndPoint: ApiHelper.makeUrlPath(['venuegroups', current.id]),
    });
  }


  onActions(current) {
    const actions = []
    actions.push(
      <Link to={'/admin/venuegroups/' + current.id + '/items'} key={current.id + '-items'}>
        <Tooltip title='Screens in Group' placement='top-start'>
          <span className={css(AppStyles.entityTableLinkIcon)}>
            <i className='material-icons-outlined'>list</i>
          </span>
        </Tooltip>
      </Link>
    )
    actions.push(UiHelper.buttonEdit(this, current))
    // actions.push(UiHelper.buttonDelete(this, current))
    return actions
  }

  onList() {
    this.setState({ searchText: '', inProcessOnList: true, stateFilterValue: 'LIVE' }, () => { this.onFetchVenueGroup() })
  }

  onSearch = (searchText) => {
    this.setState({ searchText: searchText, inProcessSearch: true }, () => { this.onFetchVenueGroup() })
  }

  onStateFilter(e) {
    const selectedState = e.target.value
    this.setState({
      stateFilterValue:selectedState
    })
  }

  getQueryParams() {
    const queryParams = { groupId: this.orgId, pb: 'fieldDef' }
    if (this.state.searchText) {
      queryParams.query = this.state.searchText
    }
    if (this.state.stateFilterValue) {
      queryParams.state = this.state.stateFilterValue
    }
    return queryParams
  }

  onFetchVenueGroup() {
    ApiHelper.call(
      {
        method: 'GET', paths: ['miscs', 'venuegroups'], queryParams: this.getQueryParams()
      },
      function (err, data) {
        console.log(err, data)
        if (err) {
          this.emptyText = Helper.getErrorMsg(err)
          this.setState({
            errMsg: Helper.getErrorMsg(err),
            items: [],
            inProcessSearch: false,
            inProcessOnList: false
          })
          return
        }
        this.setState({
          successMsg: '',
          errMsg: null,
          items: data.items,
          inProcessSearch: false,
          inProcessOnList: false
        })
      }.bind(this));
  }

  renderAboveTable() {
    return (
      <div className={css(Styles.searchContainer)}>
        <SearchBar
          hint={'Search'}
          inProcessSearch={this.state.inProcessSearch || false}
          inProcessOnList={this.state.inProcessOnList || false}
          onList={this.onList.bind(this)}
          onSearch={this.onSearch.bind(this)}
          searchText={this.state.searchText}
          onSinglePickerFilter={this.onStateFilter.bind(this)}
          singleSelectPicker={
            {
              options: [
                { key: 'LIVE', value: 'LIVE' },
                { key: 'DISABLED', value: 'DISABLED' },
                { key: '_ALL', value: 'ALL' }
              ],
              defaultValue: this.state.stateFilterValue,
              // title: 'Select State'
            }
          }
          showRecentButtonText={'Reset Filter'}>
        </SearchBar>
      </div>
    )
  }
}

const Styles = StyleSheet.create({
  spanValue: {
    fontSize: 12
  },
  img: {
    height: 30
  },
  searchContainer: {
    display: 'flex',
    flex: 1,
    flexDirection: 'column',
  }
})


// WEBPACK FOOTER //
// ./src/screens/admin/Venuegroups.js